export const data = [
    {
        id: 1,
        title: 'Hissenet Analytics Verileri',
        titleEN: 'Hissenet Analytics Data',
        image: 'https://srv-cdn.onedio.com/store/1f380749e2dc4e146a4db4442562bc7a70b1f44b1ee6dfa0a369d90d9201502b.png',
        imageEN: 'https://srv-cdn.onedio.com/store/22a4883ba8cc283deb4c44f32018b946adb3a9ad04cd293d4d97a85518d1ee71.png',
        active: true
    },
    {
        id: 2,
        title: 'Cinsiyet',
        titleEN: 'Gender',
        image: 'https://srv-cdn.onedio.com/store/13f617b390a5f9180283d24e0a2564f1cab828feab8f45f1469d6907266bb070.png',
        imageEN: 'https://srv-cdn.onedio.com/store/13f617b390a5f9180283d24e0a2564f1cab828feab8f45f1469d6907266bb070.png',
        active: false
    },
    {
        id: 3,
        title: 'Yaş Kırılımı',
        titleEN: 'Age Distribution',
        image: 'https://srv-cdn.onedio.com/store/2b6f76a4ff192867dc81ceb0ac6cd0c25549742fa385b96caf345e6813c818d3.png',
        imageEN: 'https://srv-cdn.onedio.com/store/f9f905d93f6f52cc46ee2642eae4426cd5f253c88672c8c5fc7987b69873f44f.png',
        active: false
    },
    {
        id: 4,
        title: 'Sosyal Medya',
        titleEN: 'Social Media',
        image: 'https://srv-cdn.onedio.com/store/20856251864a8ff00bbe6475a4ffacd8ce86b9e257d17f45b7937e0d3ac258f7.png',
        imageEN: 'https://srv-cdn.onedio.com/store/f1c508f796901e09149c10c2750a3f858426b9d4e100edd90140d0a29c72762e.png',
        active: false
    }
] 